module.exports = __webpack_public_path__ + "img/ibi.f33a234d.svg";